import PopupShell from "@/components/popup-shell";
import globals from "@/globals";
import * as signals from "@/signals";
import { sleep } from "@/utils";
import { t } from "i18next";
import {
	ChangeEvent,
	FormEvent,
	JSX,
	useEffect,
	useId,
	useRef,
	useState,
} from "react";

function PromptPopup(): JSX.Element {
	const [inputValue, setInputValue] = useState<string>(
		signals.prompt.value.defaultText || "",
	);
	const [isClosing, setIsClosing] = useState(false);

	const inputRef = useRef<HTMLInputElement>(null);

	const dataListId = useId();
	const inputId = useId();

	const closePromptPopup = async (): Promise<void> => {
		globals.promptCallback = null;
		setIsClosing(true);
		await sleep(globals.ANIMATION_WAIT_TIME);
		signals.prompt.value = {};
		setIsClosing(false);
	};

	const handleInputChange = (event: ChangeEvent<HTMLInputElement>): void => {
		setInputValue(event.target.value);
	};

	const handleSubmit = async (event: FormEvent): Promise<void> => {
		event.preventDefault();
		const { promptCallback } = globals;
		await closePromptPopup();
		void promptCallback?.(inputValue);
	};

	const dataListOptionElements = signals.prompt.value.dataList?.map(
		(item) => {
			return (
				<option
					key={item}
					value={item}
				/>
			);
		},
	);

	useEffect(() => {
		window.setTimeout(() => {
			inputRef.current?.focus();
		}, globals.ANIMATION_WAIT_TIME);
	}, []);

	return (
		<PopupShell
			className="msg-box"
			isClosing={isClosing}
			onClose={closePromptPopup}
			isOpen
		>
			<form onSubmit={(event) => void handleSubmit(event)}>
				<label
					className="msg-box-txt"
					htmlFor={inputId}
				>
					{signals.prompt.value.text}
				</label>
				<input
					className="input-box"
					id={inputId}
					list={dataListId}
					onChange={handleInputChange}
					ref={inputRef}
					type="text"
					value={inputValue}
				/>
				{signals.prompt.value.dataList && (
					<datalist id={dataListId}>
						{dataListOptionElements}
					</datalist>
				)}
				<div className="button-container">
					<button
						className="button"
						onClick={() => void closePromptPopup()}
						type="button"
					>
						{t("cancel")}
					</button>
					<button
						className="default-button"
						type="submit"
					>
						{t("ok")}
					</button>
				</div>
			</form>
		</PopupShell>
	);
}

export default PromptPopup;
